export default "__VITE_ASSET__BoCPgRVX__"